<template>
  <div class="select-wrapper" :style="wrapperStyle">
    <select @change="urlModifier('meter', $event)" :style="selectStyle">
      <option>{{ prompt }}</option>
      <optgroup v-if="visibleMeters.length" label="Visible Meters">
        <option
          v-for="meter in visibleMeters"
          :key="meter.slug"
          :value="meter.slug"
          :selected="meter.slug == selectedMeter"
          >{{ meter.name }}
        </option>
      </optgroup>
      <optgroup v-if="hiddenMeters.length" label="Hidden Meters">
        <option
          v-for="meter in hiddenMeters"
          :key="meter.slug"
          :value="meter.slug"
          :selected="meter.slug == selectedMeter"
          >{{ meter.name }}
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    prompt: String,
    visibleMeters: Array,
    hiddenMeters: Array,
  },

  data: function () {
    return {
      // Width is a share of the header row, not the length of the selected name: long meter
      // names used to be clipped. The floor keeps it usable on narrow screens.
      wrapperStyle: {
        width: '40%',
        minWidth: '220px',
      },
      selectStyle: {
        maxWidth: 'none',
        width: '100%',
      },
      selectedMeter: '',
    };
  },

  methods: {
    urlModifier: (parameter, value) => {
      let url = new URL(window.location.href);

      url.searchParams.delete(parameter);
      value = value.target.value;
      url.searchParams.set(parameter, value);

      url.searchParams.sort();
      window.location.href = url;
    },
  },

  mounted: function () {
    let url = new URL(window.location.href);
    this.selectedMeter = url.searchParams.get('meter');
  },
};
</script>
